import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import HomeLanding from './landingPage/homeLanding';
import HomeDashboard from './dashboard/homeDashboard';

class Home extends Component {

  static propTypes = {
    auth: React.PropTypes.shape({
      loggedIn: PropTypes.bool.isRequired
    }).isRequired
  }

  render () {
    const { loggedIn } = this.props.auth;

    if (!loggedIn) {
      return <HomeLanding />;
    } else {
      return <HomeDashboard />;
    }
  }

}

export default connect(
  state => ({ auth: state.auth })
)(Home);



// WEBPACK FOOTER //
// ./src/views/home.jsx